import React, { Component } from 'react';

import classNames from 'classnames';
import { Dropdown, Labeled, Select } from 'components/ClubComponents';
import SearchInputSelectOptions from 'components/input/search/SearchInputSelectOptions';
import { I18n, translate } from 'components/translate';
import { isObject } from 'helpers/Object';
import get from 'lodash/get';
import { inject, observer } from 'mobx-react';
import { CommunityService } from 'modules/community';
import CommentListService from 'modules/community/commentList/CommentListService';
import { userDataPropType } from 'modules/community/commentList/DataPropType';
import UsersListOption from 'modules/community/commentList/UsersListOption';
import PropTypes from 'prop-types';

import BulkActionsDropdownItem from './BulkActionsDropdownItem';
import CommentListHeaderContentSelect from './CommentListHeaderContentSelect';
import NotificationMacroDropdownItem from './NotificationMacroDropdownItem';

import './CommentListHeader.scss';

const massActionsTypes = {
  approve: 'approve',
  disapprove: 'disapprove',
  spam: 'spam'
};

@inject((stores) => ({
  academy: stores.MembershipStore.academy,
  loadingUsers: stores.CommunityStore.loadingUsers,
  user: stores.CommunityStore.user
}))
@observer
@translate()
export default class CommentListHeader extends Component {
  // #region set up
  static propTypes = {
    academy: PropTypes.bool,
    activedTab: PropTypes.number,
    classesList: PropTypes.array,
    commentStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    commentStatusList: PropTypes.array,
    fetchCommentsData: PropTypes.func,
    fetchUsers: PropTypes.func,
    label: PropTypes.object,
    loadingUsers: PropTypes.bool,
    membershipClass: PropTypes.object,
    modal: PropTypes.object,
    notificationsMacros: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        type: PropTypes.string
      })
    ),
    setClass: PropTypes.func,
    setCommentStatus: PropTypes.func,
    setPagesAndModules: PropTypes.func,
    pagesAndModules: PropTypes.array,
    t: PropTypes.func,
    toogleModal: PropTypes.func,
    toogleModalMacro: PropTypes.func,
    user: PropTypes.string,
    usersData: PropTypes.shape(userDataPropType)
  };

  static defaultProps = {
    usersData: {}
  };

  constructor(props) {
    super(props);

    this.SearchInputSelectOptionsRef = React.createRef();

    this.onClean = this.onClean.bind(this);
    this.setUser = this.setUser.bind(this);
    this.setUserValue = this.setUserValue.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { activedTab, user } = this.props;

    if (prevProps.activedTab !== activedTab) {
      this.cleanUser();
    }

    if (isObject(user) && user.userEmail !== this.searchInputValue) {
      this.searchInputValue = user.userEmail;
    }
  }
  // #endregion

  createAction = (icon, label, type) => {
    const { modal, toogleModal } = this.props;

    return {
      icon,
      label,
      handler: () => toogleModal(modal.open, type)
    };
  };

  onClean() {
    const { fetchCommentsData } = this.props;

    this.cleanUser();

    fetchCommentsData && fetchCommentsData(CommunityService.commentListParams);
  }

  cleanUser() {
    this.setUserValue('');
  }

  setUser(user) {
    CommunityService.setData({ user });
  }

  setUserValue(user) {
    this.setUser(user);

    this.searchInputValue = user.userEmail;
  }

  handleSelectClass = (e) => {
    const { setClass } = this.props;
    const selectedClass = get(e, 'target.value', null);

    setClass(selectedClass);
  };

  handleSelectStatus = (e) => {
    const { setCommentStatus } = this.props;
    const selectedStatus = get(e, 'target.value');

    setCommentStatus(selectedStatus);
  };

  handleSelectPagesAndModules = (selectedPagesAndModules) => {
    const { setPagesAndModules } = this.props;

    setPagesAndModules(selectedPagesAndModules);
  };

  get searchInputValue() {
    if (
      this.SearchInputSelectOptionsRef &&
      this.SearchInputSelectOptionsRef.current
    ) {
      return this.SearchInputSelectOptionsRef.current.value;
    }
  }

  set searchInputValue(value) {
    if (
      this.SearchInputSelectOptionsRef &&
      this.SearchInputSelectOptionsRef.current
    ) {
      const ref = this.SearchInputSelectOptionsRef.current.SearchInputRef;

      if (ref && ref.current) {
        ref.current.value = value;
      }
    }
  }

  get hasResults() {
    const { usersData } = this.props;

    return Boolean(Object.keys(usersData).length);
  }

  renderCommentStatus() {
    const { commentStatus, commentStatusList, activedTab } = this.props;

    return (
      <Labeled
        data-test="c-comment-filter-status"
        mode={Labeled.MODE.SMALL}
        className={classNames('comment-list__filter__comment-status', {
          'hidden-field': !CommentListService.isAllTab(activedTab)
        })}
        label={<I18n html label="community.comment_status" />}
      >
        <Select
          name="comment-status"
          onChange={this.handleSelectStatus}
          options={commentStatusList}
          value={commentStatus}
        />
      </Labeled>
    );
  }
  renderClassAction() {
    const { membershipClass, classesList, activedTab } = this.props;

    const filterClassStyles = classNames(
      'comment-list__filter__class',
      {
        'comment-list__filter__class__comment-status-field--mobile':
          CommentListService.isAllTab(activedTab)
      },
      {
        'comment-list__filter__class--comment-status-inactive':
          !CommentListService.isAllTab(activedTab)
      }
    );

    return (
      <Labeled
        data-test="c-comment-filter-class"
        mode={Labeled.MODE.SMALL}
        className={filterClassStyles}
        label={<I18n html label="general.class" />}
      >
        <Select
          clearable
          name="class"
          onChange={this.handleSelectClass}
          options={classesList}
          placeholder={<I18n label="general.select_all" />}
          value={membershipClass}
        />
      </Labeled>
    );
  }

  renderModulesAndPages() {
    const { pagesAndModules } = this.props;

    return (
      <CommentListHeaderContentSelect
        onChange={this.handleSelectPagesAndModules}
        value={pagesAndModules}
      />
    );
  }

  renderBulkActions() {
    return (
      <Labeled
        mode={Labeled.MODE.SMALL}
        className="comment-list__filter__bulk-actions"
        label={<I18n label="content_list.mass_actions" />}
      >
        <Dropdown toggle={<I18n label="general.choose_action" />}>
          <Dropdown.Items hoverable>
            {this.actionsList.map((action) => (
              <BulkActionsDropdownItem key={action.label} action={action} />
            ))}
          </Dropdown.Items>
        </Dropdown>
      </Labeled>
    );
  }

  renderNotificationMacros() {
    const { academy, notificationsMacros, toogleModalMacro, modal } =
      this.props;

    return (
      <Labeled
        mode={Labeled.MODE.SMALL}
        className={classNames('comment-list__filter__notifications-macro', {
          'hidden-field': !academy
        })}
        label={<I18n label="community.macro" />}
      >
        <Dropdown toggle={<I18n label="general.select" />}>
          <Dropdown.Items hoverable>
            {notificationsMacros.map((macro) => (
              <NotificationMacroDropdownItem
                key={macro.id}
                macro={macro}
                modal={modal}
                toogleModalMacro={toogleModalMacro}
              />
            ))}
          </Dropdown.Items>
        </Dropdown>
      </Labeled>
    );
  }

  get actionsList() {
    const { label } = this.props;

    return [
      this.createAction('check', label.approve, massActionsTypes.approve),
      this.createAction('times', label.disapprove, massActionsTypes.disapprove),
      this.createAction('exclamation', label.spam, massActionsTypes.spam)
    ];
  }

  get showOptions() {
    const { usersData } = this.props;

    return usersData && usersData.content && !CommunityService.hasUserSelected;
  }

  // #region render
  render() {
    const { fetchUsers, usersData, fetchCommentsData, loadingUsers } =
      this.props;

    return (
      <div className="comment-list__filter">
        <SearchInputSelectOptions
          className="comment-list__filter__search"
          disabled={CommunityService.hasUserSelected}
          fetchData={fetchUsers}
          key="search-input-select-options"
          loading={loadingUsers}
          numberOfElements={usersData.numberOfElements}
          onClean={this.onClean}
          onChange={this.setUser}
          ref={this.SearchInputSelectOptionsRef}
          showOptions={this.showOptions}
          totalElements={usersData.totalElements}
        >
          <UsersListOption
            fetchData={fetchCommentsData}
            setUserValue={this.setUserValue}
            usersData={usersData}
          />
        </SearchInputSelectOptions>

        {this.renderCommentStatus()}

        {this.renderClassAction()}

        <div className="comment-list__filter__temporary-block">
          {this.renderModulesAndPages()}

          {this.renderNotificationMacros()}

          {this.renderBulkActions()}
        </div>
      </div>
    );
  }
  // #endregion
}
